import { KdabraTabs } from 'src/components/Tabs'
import * as S from './Tabs.styles'
import { TabComponent } from './Tabs.utils'

export enum OptionsNames {
  Attendance = 'ATENDIMENTO',
  Queue = 'FILA',
  PreQueue = 'PRÉ FILA',
  AttendanceFresh='ATENDIMENTO FRESH',
  QueueFresh = 'FILA FRESH',
  ReturnInvoices = 'NOTAS DE DEVOLUÇÃO',
  History = 'HISTÓRICO',
  SupplierRelease = 'LIBERAR FORNECEDOR',
}

const options = {
  [OptionsNames.Attendance]: {
    label: OptionsNames.Attendance,
    asTab: true,
  },
  [OptionsNames.Queue]: {
    label: OptionsNames.Queue,
    asTab: true,
  },
  [OptionsNames.PreQueue]: {
    label: OptionsNames.PreQueue,
    asTab: true,
  },
  [OptionsNames.AttendanceFresh]: {
    label: OptionsNames.AttendanceFresh,
    asTab: true,
  },
  [OptionsNames.QueueFresh]: {
    label: OptionsNames.QueueFresh,
    asTab: true,
  },
  [OptionsNames.ReturnInvoices]: {
    label: OptionsNames.ReturnInvoices,
    asTab: false,
  },
  [OptionsNames.History]: {
    label: OptionsNames.History,
    asTab: true,
  },
  [OptionsNames.SupplierRelease]: {
    label: OptionsNames.SupplierRelease,
    asTab: true,
  },
}

export default ({ activeTab, onTabChange }) => (
  <S.Wrapper>
    <KdabraTabs>
      {Object.values(options).map((tab) => {
        const { label, asTab } = tab
        const isFresh = label.includes('FRESH')

        return asTab && (
          <TabComponent
            key={label}
            isFresh={isFresh}
            title={label}
            active={activeTab === label}
            onClick={() => onTabChange(label)}
          />
        )
      })}
    </KdabraTabs>
  </S.Wrapper>
)
